// A client's words with who said them. Used in the project sheet and once on the home page.
const Testimonial = ({ quote, className }) => (
  <figure className={['testimonial', className].filter(Boolean).join(' ')}>
    <blockquote>
      <p>{quote.text}</p>
    </blockquote>
    <figcaption>
      {quote.name}
      {quote.role && <span>{quote.role}</span>}
    </figcaption>
  </figure>
);

export default Testimonial;
